import React, { useEffect, useRef } from "react";
import { ArrowUpDown } from "lucide-react";
import { thClass } from "../../stock/StockUI";

// Shared bits of the « Fiches techniques » tabs (same look as the Stock lists)

export const formatCurrency = (value) => {
    if (value === null || value === undefined) return "0.00";
    return parseFloat(value).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, " ");
};

// Green / amber / red pill by margin level
export const MarginBadge = ({ value }) => (
    <span className={`inline-flex px-2 py-0.5 text-xs font-semibold rounded-full tabular-nums ${
        value > 30
            ? 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400'
            : value > 15
                ? 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400'
                : 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400'
    }`}>
        {formatCurrency(value)}%
    </span>
);

// Sortable column header
export const SortTh = ({ label, sortKey, sortConfig, onSort, align = 'left' }) => (
    <th className={`${thClass} ${align === 'right' ? 'text-right' : ''}`}>
        <button
            type="button"
            onClick={() => onSort(sortKey)}
            className={`inline-flex items-center gap-1 uppercase tracking-wider focus:outline-none hover:text-primary ${align === 'right' ? 'ml-auto' : ''} ${sortConfig.key === sortKey ? 'text-primary' : ''}`}
        >
            {label}
            <ArrowUpDown className={`w-3 h-3 ${sortConfig.key === sortKey ? '' : 'opacity-40'}`} />
        </button>
    </th>
);

export const tdClass = "px-6 py-4 whitespace-nowrap text-sm";

export const ErrorLine = ({ message }) => (
    <p className="px-4 py-8 text-center text-sm text-red-500">Erreur : {message}</p>
);

// Runs `onRequest` when the page header « Nouveau » bumps the key — but not on
// mount, so switching back to a tab doesn't reopen its create form.
export const useCreateRequest = (createRequestKey, onRequest) => {
    const initialKey = useRef(createRequestKey);
    useEffect(() => {
        if (createRequestKey !== initialKey.current) onRequest();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [createRequestKey]);
};
